
/*

Adityaa 09/27/2022 2700632669 Fixed multiple toast issue for change password screen in User management
Ashraf 10/16/2022 2700632669 added code comments in search user management
Rohini 10/31/2022 2700632669 changed classname for the button
 Sai Maheshwar 11/11/2022 3031689933  integrated locked process
 Ashraf 12/07/2022  3031689933 fixed user login name field
 suresh peddavoora 02/24/2023 3031689933 New UI changes added
Ravi 06/26/2023 3031689933 fixed submit issue

*/

import React, {useState, useContext, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {useForm} from 'react-hook-form';
import {TextField, FormHelperText, InputAdornment, IconButton, Button} from '@material-ui/core';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {
  postChangePassword,
  resetMessage,
  resetStatus,
} from '../../../redux/reducers/UserManagement/AddUser';
import {makeStyles} from '@material-ui/styles';
import {useHistory} from 'react-router';
import {releaseLockedProcess} from '../../../util/Rest';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const useStyles = makeStyles(() => ({
  disabled: {
    '& .MuiOutlinedInput-input': {
      opacity: '1 !important',
      color: '#222222 !important',
    },
  },
}));

// where the password for particular user can be changed (2700643010)
const ChangePassword = ({usersId, setPasswordDialog, selected, userChange}) => {
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const classes2 = useStyles();

  const {passwordStatus, errorMsg, successMsg} = useSelector(({addUser}) => addUser);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {roleData} = useSelector(({role}) => role);

  // to show or hide the password entered (2700643010)
  const toggleNewPassword = () => {
    setNewPasswordShown(!newPasswordShown);
  };
  const toggleConfirmPassword = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  // initial form values (2700643010)
  const initialValues = {
    userName: userChange ? userChange : '',
    newPassword: '',
    confirmPassword: '',
  };

  // reset redux state after success, error or password change status is changed (2700643010)
  useEffect(() => {
    if (errorMsg || successMsg || passwordStatus) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
      }, 2500);
    }
    if (passwordStatus === 200) {
      setTimeout(() => {
        setPasswordDialog(false);
        if (roleData?.userDetails?.userName === userChange) {
          releaseLockedProcess();
          sessionStorage.clear();
          history.push('/login');
        }
      }, 3200);
    }
  }, [passwordStatus, errorMsg, successMsg]);

  // validations for new password, confirm password fields which has to match (2700643010)
  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('Please enter your new password')
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        'Password must contain at least 8 characters, one uppercase, one lower case, one numeric and one special case character',
      ),

    confirmPassword: Yup.string()
      .required()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
      .required('Please confirm Your new password'),
  });

  const {handleSubmit, errors, register} = useForm({
    mode: 'onSubmit',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  // saving new password for the user by api call (2700643010)
  const handleResetPassword = (data) => {
    dispatch(submissionStart());
    dispatch(
      postChangePassword({
        confirmPassword: data?.confirmPassword,
        newPassword: data?.newPassword,
        userId: usersId ? usersId : 0,
      }),
    );
  };

  return (
    <>
      <div>
        <form onSubmit={handleSubmit(handleResetPassword)} noValidate>
          <div className="col-md-12 new-standard-textfields">
            <div className="form-row">
              <div className={`col-sm-12 form-group reset-password-fields`}>
                <label>USER LOGIN EMAIL</label>
                <TextField
                  margin="dense"
                  variant="outlined"
                  className={`form-control ${classes2.disabled} ${classes.labelName}`}
                  name="userName"
                  inputRef={register}
                  disabled={true}
                  fullWidth
                />
              </div>
              <div
                className={`col-sm-12 form-group reset-password-fields ${
                  errors.newPassword?.message.length > 30 ? 'mb-5' : ''
                }`}
              >
                <label>NEW PASSWORD</label>
                <TextField
                  type={newPasswordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  className={`form-control  ${classes.labelName}`}
                  name="newPassword"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.newPassword?.message)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="visible-icon mx-2"
                          aria-label="toggle password visibility"
                          onClick={toggleNewPassword}
                        >
                          {newPasswordShown ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormHelperText style={{color: 'red'}} variant="outlined">
                  {errors.newPassword?.message ? errors.newPassword.message : ''}
                </FormHelperText>
              </div>
              <div className="col-sm-12 form-group reset-password-fields">
                <label>CONFIRM PASSWORD</label>
                <TextField
                  type={confirmPasswordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  className={`form-control  ${classes.labelName}`}
                  name="confirmPassword"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.confirmPassword?.message)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton className='mx-2'
                          aria-label="toggle password visibility"
                          onClick={toggleConfirmPassword}
                        >
                          {confirmPasswordShown ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormHelperText style={{color: 'red'}} variant="outlined">
                  {errors.confirmPassword?.message ? errors.confirmPassword.message : ''}
                </FormHelperText>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center new-standard-textfields">
            <Button
              type="submit"
              variant="outlined"
              className={`mx-1 search-btn ${classes.buttonRoot}`}
              color="primary"
              disabled={enabledSubmission}
            >
              Change Password
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;
